<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>审核</BreadcrumbItem>
                    <BreadcrumbItem>产品审核</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">产品审核</div>

                <div style="display:flex;margin-top:15px">
                    <el-input placeholder="请输入搜索的内容" size="small" class="marLeft" style="width: 200px;"
                        v-model="searchField" clearable>
                    </el-input>
                    <el-button type="primary" size="small" @click="searchChick()" class="marLeft">搜索</el-button>
                </div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="hostExcelExportBackChange">
                    <i class="icon iconfont icon-downLoad2"></i>
                    <span>导出</span>
                </div>
            </div>

        </div>
        <div class="header-tabs">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
                <TabPane :label="showTabs == '0' ? '新品荟审核' + '(' + totalCount + ')' : '新品荟审核'" name="0">
                </TabPane>
                <TabPane :label="showTabs == '1' ? '臻品荟审核' + '(' + totalCount + ')' : '臻品荟审核'" name="1">
                </TabPane>
            </Tabs>
        </div>

        <div class="" style="display: flex;margin: 20px;justify-content: space-between;">
            <RadioGroup v-model="newsAudit" type="button" @on-change="initStatus">
                <Radio label="0">待审核</Radio>
                <Radio label="1">已审核</Radio>
            </RadioGroup>
            <div>
                <Poptip confirm title="确定批量通过审核吗?" @on-ok="okPL" @on-cancel="cancelPL">
                    <Button type="error">批量通过</Button>
                </Poptip>

                <Button type="error" style="margin-left: 20px;" @click="rejectPl">批量驳回</Button>
            </div>
        </div>

        <div class="layout-content" style="background: transparent;">
            <!-- <div v-if="list.length"> -->
            <div v-if="list.length">
                <Table :columns="newsAudit == '0' ? columns : columnsNoHandel" :loading="loading" :data="list"
                    ref="selection" @on-selection-change="changeEvent">
                    <template slot-scope="{ row }" slot="compName">{{ row.compName }}</template>
                    <template slot-scope="{ row }" slot="productName">{{ row.productName }}</template>
                    <template slot-scope="{ row }" slot="productCategory">
                        {{ row.productCategory ? row.productCategory : 'ppp' }}
                    </template>
                    <template slot-scope="{ row }" slot="inTime">
                        <span v-if="row.inTime">{{ row.inTime | dateFormat }}</span>
                    </template>
                    <template slot-scope="{ row }" slot="auditStatus">
                        <!-- {{ row.auditStatus }} -->
                        <span v-if="row.auditStatus == 'wait'">待审核</span>
                        <span v-if="row.auditStatus == 'pass'">通过</span>
                        <span v-if="row.auditStatus == 'notpass'">不通过</span>
                    </template>
                    <template slot-scope="{ row }" slot="isdeal">
                        <!-- 0 -->
                        <div v-if="newsAudit == '0'">
                            <span class="lookClass" style="cursor:pointer" @click="detailInfo(row, '1')">查看</span>
                            <span class="spanClass">|</span>

                            <span>
                                <Poptip confirm :title="PoptipTitle" @on-ok="setAudit(row)" placement="left">
                                    <span class="lookClass" @click="handleP(row, '3')">通过</span>
                                </Poptip>
                            </span>
                            <span class="spanClass">|</span>
                            <span class="deleteClass" style="cursor:pointer" @click="rejectP(row, '0')">驳回</span>

                        </div>
                        <!-- 1 -->
                        <div v-if="newsAudit == '1'">
                            <span class="lookClass" style="cursor:pointer" @click="detailInfo(row, '1')">查看</span>
                        </div>


                    </template>
                </Table>
                <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
                    <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
                        @on-change="changePage" @on-page-size-change="changePageSize" />
                </div>
            </div>
            <div class="u-empty" v-else>暂无数据</div>
        </div>

        <iModal :title="modelTitle" v-model="rejectModel" class-name="vertical-center-modal" width="600px"
            :mask-closable="false">

            <Input v-model="rejectValue" type="textarea" :rows="4" placeholder="请输入..."></Input>

            <div slot="footer">
                <Button type="primary" @click="handleSubmitReject()">确定</Button>
                <Button @click="rejectModel = false">取消</Button>
            </div>
        </iModal>
        <!-- 批量驳回 -->
        <iModal title="批量驳回" v-model="dialogPl" class-name="vertical-center-modal" width="600px"
            :mask-closable="false">

            <Input v-model="rejectValuePl" type="textarea" :rows="4" placeholder="请输入..."></Input>

            <div slot="footer">
                <Button type="primary" @click="handleSubmitRejectPl()">确定</Button>
                <Button @click="dialogPl = false">取消</Button>
            </div>
        </iModal>
        <div class="catalogue-content"></div>

    </div>
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
    name: 'exhibition-info-carApply',
    data () {
        return {
            newsAudit: "0",
            productTypeOptions: [
                {
                    value: '选项1',
                    label: '黄金糕',
                },
            ],
            productTypeValue: '',

            modalDetail: false,
            loading: false,
            dialogPl: false,
            rejectValuePl: '',

            editBrand: false,
            editBrandnfo: null,
            editTopic: false,
            editTopicnfo: null,
            search: '',
            editInfo: null,
            pageSize: 20,
            pageIndex: 1,
            totalCount: 0,
            columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '展商',
                    slot: 'compName',
                    align: 'center',
                },
                {
                    title: '产品名称',
                    slot: 'productName',
                    align: 'center',
                },
                {
                    title: '产品类别',
                    slot: 'productCategory',
                    align: 'center',
                },
                {
                    title: '提交时间',
                    slot: 'inTime',
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'isdeal',
                    align: 'center',
                },
            ],
            columnsNoHandel: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '展商',
                    slot: 'compName',
                    align: 'center',
                },
                {
                    title: '产品名称',
                    slot: 'productName',
                    align: 'center',
                },
                {
                    title: '产品类别',
                    slot: 'productCategory',
                    align: 'center',
                },
                {
                    title: '提交时间',
                    slot: 'inTime',
                    align: 'center',
                },
                {
                    title: '审核状态',
                    slot: 'auditStatus',
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'isdeal',
                    align: 'center',
                },
            ],
            oppTime: [],
            searchField: '',
            list: [],
            selection: [], // 选中项目
            addShow: false,
            rejectModel: false,
            modelTitle: '',
            rowUser: {},
            optOld: {},
            showTabs: '0',
            PoptipTitle: '',
            option: {},
            stateInit: '',
            rejectValue: '',
            form: {
                category: [], // 展品分类
            },
            type: [],
            idCategory: '',
            proIdType: "fcb459d0-9565-413b-832d-f25bba4c3567",
            statusProType: ['wait'],
        }
    },
    components: {
        // exhibitionCarYes,
        // exhibitionCarNo
    },
    computed: {
        ...mapGetters({
            exhibition: 'loginModule/getExhibition',
            exhibitionInfo: 'hostSetModule/getHostExhibition',
            hostExhibition: 'hostSetModule/getHostExhibition',
            exhibitionId: 'hostSetModule/getHostExhibition',

        }),
    },
    created () {
        document.title = '中国国际医疗器械博览会 - 产品审核'
        this.initProType()
        this.init()
    },
    methods: {
        ...mapActions({
            getHostBuySupply: 'hostSetModule/getHostBuySupply',
            putHostUpdateState: 'hostSetModule/putHostUpdateState',
            getHostCallingAgain: 'hostSetModule/getHostCallingAgain',
            getBuyExport: 'hostSetModule/getBuyExport',
            //   商机
            busOppNewRealeaseGetPageList:
                'hostSetModule/busOppNewRealeaseGetPageList',
            getProductByGroupId: 'categoryModule/getProductByGroupId', // 获取  产品类别
            busOppNewRealeasePutUpdate: 'hostSetModule/busOppNewRealeasePutUpdate', // 修改
            busOppNewRealeaseExcelExportHost:
                'hostSetModule/busOppNewRealeaseExcelExportHost',
            newRealeaseSetIsShow: 'hostSetModule/newRealeaseSetIsShow',

            getAuditLogPass: 'hostSetModule/getAuditLogPass',
            getAuditLogPut: 'hostSetModule/getAuditLogPut',
            ProductTagAuditLogAuditAll: 'hostSetModule/ProductTagAuditLogAuditAll',
            postProductTagAuditLogExcelbyPage: 'hostSetModule/postProductTagAuditLogExcelbyPage',



            postProductTagAuditLogPage: 'hostSetModule/postProductTagAuditLogPage',
        }),
        switchBrand (name) {
            this.pageIndex = 1
            if (name == 0) {
                this.proIdType = 'fcb459d0-9565-413b-832d-f25bba4c3567'
            }
            if (name == 1) {
                this.proIdType = '45866a37-7712-4177-8f77-0183d1357578'
            }

            this.init()
        },

        initStatus () {
            this.pageIndex = 1
            if (this.newsAudit == 0) {
                this.statusProType = ['wait']
            }
            if (this.newsAudit == 1) {
                this.statusProType = ['pass', 'notpass']
            }
            this.init()

        },
        searchChick () {
            this.init()
            //     this.startDateStr = this.formatDate(this.oppTime[0])
            //   this.endDateStr = this.formatDate(this.oppTime[1])
        },
        // 转换日期格式
        formatDate (dateTime) {
            let date = new Date(dateTime)
            let YY = date.getFullYear() + '-'
            let MM =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '-'
            let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            let hh =
                (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            let mm =
                (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                ':'
            let ss =
                date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            //    return YY + MM + DD + " " + hh + mm + ss;
            return YY + MM + DD
        },

        async init () {
            let pushList = [
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 6,
                        Label: 'compName',
                        Value: `%${this.searchField || ''}%`,
                    },
                },
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 0,
                        Label: 'tagId',
                        Value: this.proIdType,
                    },
                },
            ]

            console.log(this.statusProType, 'pppppppp')

            this.option = {
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
                auditStatus: this.statusProType,
                ExhibitionId: this.exhibitionId.id,
                Wheres: {
                    type: 0,
                    Wheres: {
                        WhereGroupOperator: 0,
                        Predicates: pushList,
                    },
                },
            }

            this.loading = true
            let proData = await this.postProductTagAuditLogPage(this.option)
            if (proData) {
                this.loading = false
                // this.list = proData.items
                let resList = proData.items
                this.pageSize = proData.pageSize
                this.pageIndex = proData.pageIndex
                this.totalCount = proData.totalCount
                resList.forEach((e) => {
                    if (e.productCategory) {
                        const category = JSON.parse(e.productCategory)
                        const categoryArr = []
                        if (category) {
                            if (category.Value) {
                                categoryArr.push(category.Value)
                                if (category.List[0]) {
                                    categoryArr.push(category.List[0].Value)
                                    if (category.List[0].list) {
                                        categoryArr.push(category.List[0].list[0].Value)
                                    }
                                }

                                e.productCategory = categoryArr.join('/')
                            }
                        }
                    }
                })
                this.list = resList
                console.log(this.list, '[][][][][][][][]')
            } else {
                this.loading = false
            }
        },

        // 查询产品类别
        async initProType () {
            let categoryData = await this.getProductByGroupId({
                groupId: this.hostExhibition.groupId,
                level: 0,
                loadChild: true,
            }) // 暂时先写死了值
            if (categoryData && categoryData.length) {
                categoryData.map((c) => {
                    c.value = c.name
                    c.label = c.name
                    c.children = JSON.parse(JSON.stringify(c.list))
                    c.children.map((v) => {
                        v.value = v.name
                        v.label = v.name
                        v.children = JSON.parse(JSON.stringify(v.list))
                        v.children.map((z) => {
                            z.value = z.name
                            z.label = z.name
                            z.children = JSON.parse(JSON.stringify(z.list))
                        })
                    })
                })
                this.type = categoryData
                console.log(this.type, '888888888')
            } else {
                this.type = []
            }
        },

        async setAllAudit () {
            const reqList = []
            if (!this.selection.length) return
            this.selection.forEach((c) => {
                reqList.push(c.joinId)
            })
            const bool = await this.setOneStepAudit({
                joinIds: reqList,
            })
            if (bool && bool.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
        },
        changePage (e) {
            this.pageIndex = e
            this.init()
        },
        changePageSize (e) {
            this.pageSize = e
            this.init()
        },
        edit (item) {
            this.editInfo = item
        },
        searchPro () {
            this.pageIndex = 1
            this.init()
        },
        changeEvent (selection) {
            this.selection = selection
            console.log(this.selection);
        },

        handleP (row, index) {
            this.PoptipTitle = '您确定要通过吗？'
        },
        async setAudit (row) {
            const bool = await this.getAuditLogPass(row.id)
            if (bool && bool.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
        },
        rejectP (row, index) {
            this.rejectValue = ''
            this.rowUser = row
            this.modelTitle = '请填写驳回原因：'
            this.rejectModel = true
            //   }
        },

        // 驳回确定按钮
        async handleSubmitReject () {
            if (!this.rejectValue) {
                this.$Message.warning('驳回理由不能为空！')
                return
            }
            const option = {
                // id: this.rowUser.id,
                id: this.rowUser.id,
                setValues: {
                    Remark: this.rejectValue,
                    AuditStatus: 'notpass',
                },
            }
            let bool = await this.getAuditLogPut(option)
            if (bool && bool.successed) {
                this.rejectModel = false
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
            //   }
        },

        // 获取产品类别
        changeCategory (val) {
            let category = this.form.category
            if (val) {
                category = this.form.category = val
            }
            let data = null
            this.type.forEach((c) => {
                if (category[0] && c.name === category[0]) {
                    this.idCategory = c.id
                    data = {
                        Id: c.id,
                        Value: c.name,
                        List: [],
                    }
                    if (c.list && c.list.length && category[1]) {
                        c.list.forEach((v) => {
                            if (v.name === category[1]) {
                                this.idCategory = v.id
                                data.List[0] = {
                                    Id: v.id,
                                    Value: v.name,
                                }
                                if (v.list && v.list.length && category[2]) {
                                    v.list.forEach((j) => {
                                        if (j.name === category[2]) {
                                            this.idCategory = j.id
                                            data.List[0].list = [
                                                {
                                                    Id: j.id,
                                                    Value: j.name,
                                                    Remark: j.tag,
                                                },
                                            ]
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
            console.log(this.idCategory)
            return data
        },

        // 查看详情   传id
        detailInfo (item, index) {
            this.$router.push(
                `/host/index/pro/pro-edit?id=${item.productId}&compId=${item.compId}`
            );
            // this.$router.push(
            //     `/host/index/supply-info/business-opportunity-detail?id=${row.id || ''}`
            // )
        },
        // 修改展品显示、屏蔽
        async showToggle (item) {
            const bool = !!item.isShow
            let result = await this.newRealeaseSetIsShow({
                id: item.id,
                setValues: {
                    IsShow: bool,
                },
            })
            if (result.successed) {
                this.$Message.success('修改成功')
                this.init()
            } else {
                this.$Message.error('修改失败，请重新尝试')
            }
        },
        // 批量
        async okPL () {
            if(this.selection.length==0){
                this.$Message.warning('请选择批量操作的数据')
                return
            }
            let list =  this.selection.map(e => {
                return e.id
            })

            let opt = {
                ids: list,
                auditType:"pass",
                notPassRemark:"批量通过的数据",
            }
            const bool = await this.ProductTagAuditLogAuditAll(opt)
            if (bool && bool.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
        },
        cancelPL () {
            // this.$Message.info('You click cancel');
        },
        rejectPl () {
            if (this.selection.length == 0) {
                this.$Message.warning('请选择批量操作的数据')
                return
            }
           this.dialogPl=true
        },
          // 驳回确定按钮
          async handleSubmitRejectPl () {
            if (!this.rejectValuePl) {
                this.$Message.warning('驳回理由不能为空！')
                return
            }
            let list =  this.selection.map(e => {
                return e.id
            })
            const option = {
                ids: list,
                auditType:"notpass",
                notPassRemark:this.rejectValuePl,
            }
            let bool = await this.ProductTagAuditLogAuditAll(option)
            if (bool && bool.successed) {
                this.dialogPl = false
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
            //   }
        },

        hostExcelExportBackChange(){
            this.optOld=this.option
            this.optOld.pageIndex=1
            this.optOld.pageSize=999999

        
            this.hostExcelExportBack()
        },

        // 展商导出
        async hostExcelExportBack () {

            let res = await this.postProductTagAuditLogExcelbyPage(this.optOld)
            let filename = "产品审核导出.xlsx";
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");

        },
       



    },
}
</script>
  
<style scoped lang="scss">
.catalogue {
    .header-tool {
        min-height: 90px;
    }

    &-content {
        min-width: 1000px;
        margin: 24px;
        padding: 40px;
        min-height: 500px;
        padding-bottom: 190px;
    }
}

.cib {
    min-width: 1000px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
}

.spanClass {
    margin-left: 4px;
    margin-right: 4px;
}

.deleteClass {
    color: #f78989;
    // cursor:pointer;
}

.lookClass {
    color: #1890ff;
    cursor: pointer;
}

.marLeft {
    margin-left: 15px;
}
</style>
  